import Auth from '../auth'
import api from '@/services/api'
import { apiErrorHandler } from '../utils/apiErrors'
// import { objectToSnakeCase } from '../utils'

const UPDATES_ENDPOINT = 'updates/'

// const USERS_IMAGE_ENDPOINT = `/${USERS_ENDPOINT}/profile_pic/`

export default class UpdatesAPI {
  /**
   * Instantiate a new `UpdatesAPI`
   * @param {class} cls - The class to use to create objects.
   */
  constructor(cls) {
    this.cls = cls
  }

  /**
   * Factory method to create a new instance of `UpdatesAPI`.
   * @param {class} cls - The class to use to create objects.
   **/
  static create(cls) {
    return new UpdatesAPI(cls)
  }

  /* Get the API Client. */
  get client() {
    return api.getApiClient()
  }

  create(update) {
    const url = UPDATES_ENDPOINT
    const data = this.cls.toAPI(update)

    return this.client
      .post(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Create update API error' }))
  }

  update(update, fields = [], excludeFields = []) {
    const url = `${UPDATES_ENDPOINT}${update.id}/`
    let data = this.cls.toAPI(update, fields, excludeFields)

    return this.client
      .patch(url, data)
      .then(response => response.data)
      .then(this.cls.fromAPI)
      .catch(apiErrorHandler({ apiName: 'Update Update (ha!) Profile Data API error' }))
  }

  /**
   * Get List of Updates via the API.
   *
   * @param {object} pagination - Pagination parameters for the API.
   * @param {object} filters - Filter parameters for the API.
   *
   * @returns {Promise} - Contains the list of `Update` instances.
   */
  list({ filters = {} } = {}) {
    const authHeader = Auth.getAuthorizationHeader()
    const url = UPDATES_ENDPOINT
    const options = {
      headers: {
        ...authHeader,
      },
      params: {},
    }
    if (filters.project) {
      options.params.project = filters.project
    }
    if (filters.page) {
      options.params.page = filters.page
    }

    return this.client
      .get(url, options)
      .then(response => response.data)
      .then(data => ({
        ...data,
        results: data.results.map(this.cls.fromAPI),
      }))
      .catch(apiErrorHandler({ apiName: 'Updates API error' }))
  }

  async delete(update) {
    const url = `${UPDATES_ENDPOINT}${update.id}/`
    return this.client.delete(url).catch(apiErrorHandler({ apiName: 'Delete update API error' }))
  }
}
